import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly GENDER_KEY = 'gender';
  private readonly TIMER_KEY = 'timer';

  constructor() {}

  // Gender-related methods
  getGender(): 'male' | 'female' | null {
    const gender = this.getItem(this.GENDER_KEY);
    return gender === 'male' || gender === 'female' ? gender : null;
  }

  setGender(gender: 'male' | 'female'): void {
    this.setItem(this.GENDER_KEY, gender);
  }

  // Timer-related methods
  getTimerValue(): number | null {
    const timerValue = this.getItem(this.TIMER_KEY);
    return typeof timerValue === 'number' ? timerValue : null;
  }

  setTimerValue(value: number): void {
    this.setItem(this.TIMER_KEY, value);
  }

  // Generic storage methods
  private setItem(key: string, value: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  private getItem(key: string): any {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (e) {
      console.error('Error reading from localStorage', e);
      return null;
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error('Error removing from localStorage', e);
    }
  }

  clear(): void {
    try {
      localStorage.clear();
    } catch (e) {
      console.error('Error clearing localStorage', e);
    }
  }
}
